import { Box, useMediaQuery } from "@material-ui/core";
import { motion } from "framer-motion";
import { pageAnimation } from "../animation";
import KatalogCard from "../components/KatalogCard";
import ScrollTop from "../components/ScrollTop";

function Kataloge() {
    const matches500 = useMediaQuery('(max-width:500px)');

    return (
        <>
            <motion.div
                exit="exit"
                variants={pageAnimation}
                initial="hidden"
                animate="show"
            >
            <Box margin={!matches500 ? "3% 50px 0 50px" : "5% 15px 0 15px"} display={"grid"} gridGap={!matches500 ? "50px" : "10px"}
                 gridTemplateColumns={matches500 ? "repeat(auto-fill, minmax(250px, 1fr))" : "1fr 1fr 1fr"}>
                <KatalogCard redirect={"/kataloge/Hauptkatalog.pdf"} thumbnail={"/img/kataloge/faces/face_Hauptkatalog.png"} buttonText={"Hauptkatalog anschauen"}/>
                <KatalogCard redirect={"/kataloge/Katalog Animation.pdf"} thumbnail={"/img/kataloge/faces/face_Animation.png"} buttonText={"Animation anschauen"}/>
                <KatalogCard redirect={"/kataloge/Katalog Erlebnis & Shopping.pdf"} thumbnail={"/img/kataloge/faces/face_Erlebnis_Shopping.png"} buttonText={"Erlebnis Shopping anschauen"}/>
                <KatalogCard redirect={"/kataloge/Katalog Spielmobile.pdf"} thumbnail={"/img/kataloge/faces/face_Spielmobile.png"} buttonText={"Spielmobile anschauen"}/>
                <KatalogCard redirect={"/kataloge/Katalog Veranstaltungshighlights.pdf"} thumbnail={"/img/kataloge/faces/face_Veranstaltungshighlights.png"} buttonText={"Veranstaltungshighlights anschauen"}/>
                <KatalogCard redirect={"/kataloge/Katalog Veranstaltungskonzepte.pdf"} thumbnail={"/img/kataloge/faces/face_Veranstaltungskonzepte.png"} buttonText={"Veranstaltungskonzepte anschauen"}/>
                <KatalogCard redirect={"/kataloge/Katalog Virtual Reality Simulatoren.pdf"} thumbnail={"/img/kataloge/faces/face_Virtual Reality.png"} buttonText={"Virtual Reality anschauen"}/>
                <KatalogCard redirect={"/kataloge/Katalog Winterspezial.pdf"} thumbnail={"/img/kataloge/faces/face_Winterzauber.png"} buttonText={"Winter Spezial anschauen"}/>
                <KatalogCard redirect={"/kataloge/Katalog Animation & Entertainment.pdf"} thumbnail={"/img/kataloge/faces/face_animationandentertain.png"} buttonText={"Animation und Entertainment anschauen"}/>
            </Box>
            </motion.div>
            <ScrollTop/>
        </>
    )
}

export default Kataloge